import { render } from "./Strategicgoals.vue?vue&type=template&id=37988f4f&scoped=true"
import script from "./Strategicgoals.vue?vue&type=script&lang=js"
export * from "./Strategicgoals.vue?vue&type=script&lang=js"

import "./Strategicgoals.vue?vue&type=style&index=0&id=37988f4f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37988f4f"]])

export default __exports__